import { exists } from 'lib/types';
import { EFirebaseContext } from 'lib/types/firebase';

export const getUserName = async (id: string, ctx: EFirebaseContext) => {
  const userSnap = await ctx.usersRef().doc(id).get();
  if (!exists(userSnap)) return '';
  return userSnap.data().name;
};
